export default class SideNavToggleController {}
